export const EMAILJS_SERVICES_ID_KEY = "service_wqe6fwz";
export const EMAILJS_TEMPLATE_KEY = "template_7etua45";
export const EMAILJS_ACCOUNT_PUBLIC_KEY = "Kaw-8zk4poQV-PLcV";
